export function buildChartOptions({ t, isComparing, eventName, compareEventName }) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    onHover: (event, elements, chart) => {
      const legendHitBoxes = chart.legend?.legendHitBoxes;
      if (legendHitBoxes && event.native) {
        const { offsetX, offsetY } = event.native;
        const isOverLegend = legendHitBoxes.some(box =>
          offsetX >= box.left && offsetX <= box.left + box.width &&
          offsetY >= box.top && offsetY <= box.top + box.height
        );
        event.native.target.style.cursor = isOverLegend ? "pointer" : "default";
      }
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          padding: isComparing ? 16 : 10,
          boxWidth: isComparing ? 20 : 14,
          boxHeight: isComparing ? 14 : 10,
          usePointStyle: isComparing,
        },
        onHover: (event) => { event.native.target.style.cursor = "pointer"; },
        onLeave: (event) => { event.native.target.style.cursor = "default"; },
      },
      title: {
        display: true,
        text: isComparing
          ? `${eventName} vs ${compareEventName}`
          : `${t("Tickets")} – ${eventName}`,
        font: { size: 14, weight: "bold" },
      },
      subtitle: isComparing
        ? {
            display: true,
            text: `\u25CF ${eventName}  |  \u25C6 ${compareEventName}`,
            font: { size: 12 },
            padding: { bottom: 10 },
          }
        : { display: false },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleFont: { weight: "bold" },
        bodySpacing: 6,
        padding: 12,
      },
    },
    scales: {
      y: {
        type: "linear",
        position: "left",
        beginAtZero: true,
        title: {
          display: true,
          text: t("Daily tickets"),
        },
        ticks: {
          stepSize: 25,
        },
      },
      y1: {
        type: "linear",
        position: "right",
        beginAtZero: true,
        title: {
          display: true,
          text: t("Cumulative"),
        },
        ticks: {
          stepSize: 50,
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        afterBuildTicks: (axis) => {
          const totalLabels = axis.chart.data.labels.length;
          const lastIndex = totalLabels - 1;
          if (lastIndex < 0) return;
          // Dynamic step: aim for ~20-30 visible labels max
          const step = Math.max(1, Math.ceil(totalLabels / 25));
          const ticks = [];
          for (let i = 0; i < totalLabels; i += step) {
            ticks.push({ value: i });
          }
          if (ticks[ticks.length - 1]?.value !== lastIndex) {
            ticks.push({ value: lastIndex });
          }
          axis.ticks = ticks;
        },
        ticks: {
          maxRotation: 45,
          autoSkip: false,
        },
      },
    },
  };
}
